import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-star-line"></i>
              编辑推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选漫画
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              本周必读热门韩漫推荐
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all flex flex-col"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  width="300"
                  height="420"
                />
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                  <span className="text-background-50 text-xs font-medium">开始阅读</span>
                </div>
              </div>
              <div className="p-3 md:p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[11px] text-foreground-500 mb-2 flex-wrap flex gap-1">
                  {item.genre.split(' / ').map((g) => (
                    <span key={g} className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-500 whitespace-nowrap">
                      {g}
                    </span>
                  ))}
                </p>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2 mt-auto">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}